import axios from 'axios';
import util from '@/common/util';

export const EXTENT_TYPE = {
    LISTING: 'LISTING',
    QUICKREPLY: 'QUICKREPLY'
};

// chime-chat  various services 
export default {
    /**
     *
     * @param {*} sessionInfo
     * sessionInfo.userId  for this station  agentId
     * sessionInfo.sessionId  conversation  Id  from  chatbox_visitor_session_id cookie  extract from 
     *  If any, store the  cookie  None or nothing 
     */
    async getVisitorToken(sessionInfo) {
        //  The return result is  {data,status}  format 
        let { data } = await axios.get(
            '/api/chatbot/ai/assistant/visitors/enable',
            {
                params: sessionInfo
            }
        );
        // TODO:  Configure how to get from the database here , If configured  AI  mode returns 
        return data;
    },
    //  third party  chatbox  Trigger login logic 
    async thirdPartySignLog(authData) {
        let res = await axios.post('/api-site/third-party/login', authData);
        let { data } = res;
        return data;
    },
    async thirdPartyRegister(registerData) {
        let res = await axios.post(
            '/api-site/third-party/register',
            registerData
        );
        let { data } = res;
        // TODO:  Here you must ensure that the registration is successful 
        return data;
    },
    async getAgentInfo(id = 0) {
        let res = await axios.post('/api-graphql', {
            query: `{agent(id:${id}){fullName,image}}`
        });

        return res;
    },
    async getCompanyInfo() {
        let {
            data: { logo }
        } = await axios.get('/api-site/place-data', {
            params: {
                fetcher: 'data',
                source: 'logo'
            }
        });
        let {
            data: { company = {} }
        } = await axios.post('/api-graphql', {
            query: `{company{name}}`
        });
        return {
            name: company.name,
            img: logo
        };
    },

    pushStatus(userInfo) {
        if (userInfo) {
            userInfo.t = Date.now();
        }
        return axios.get('/api/chatbot/AI/assistant/lead/push/status', {
            params: userInfo
        });
    },
    //  The service triggered when the interface is sent successfully 
    addChat(msg) {
        return axios.get('/api-site/addChat', {
            params: msg
        });
    },
    getQuickReply(pageType, agentId) {
        let url = `/api/chatbot/quick-reply-config/${pageType}`;
        if (agentId) {
            url += `?agentId=${agentId}`;
        }
        return axios.get(url);
    },
    addChatToAgent(msg) {
        return axios.post('/api/chatbot/visit/chat/agent', msg);
    },
    leaveMsg(data) {
        return axios.post('/api-site/leaveMsg', data);
    },
    getChatToken() {
        return axios.post('/api-site/getLeadAccid');
    },
    sendSiteEvent(data) {
        return axios.post('/api/chatbot/visit/chat/site-event', data);
    },
    getVisitorsToken(visitLeadId) {
        return axios.get(
            `/api/chatbot/ai/assistant/visitors/nimtoken?visitId=${visitLeadId}`
        );
    },

    // twilio start
    /**
         Obtain  twilio  Authorization of  token
     */
    async getTwilioTokenByAccid(agentAccid, leadAccid) {
        return axios.get(
            `/api/chat/twilio/account?fromIdentity=${agentAccid}&toIdentity=${leadAccid}`
        );
    },
    /**
     *  Obtain  twilio  of  conversation
     * @param {*} data  {friendlyName:string,fromIdentity:string,toIdentityList:Array<string>, conversationType: 'group_chat'|'single_chat'|'notification',attributes: Map<string,Object> }
     * @returns
     */
    getTwilioConversation(data) {
        return axios.post('/api/chat/twilio/conversation', data);
    },
    // twilio end
    registerNim(accids = []) {
        return axios.post('/api/chat/registered/nimtoken/site', accids);
    },
    getYunxinAppKey(teamId) {
        return axios.get('/api/chat/nimchat/yunxin/key/info/site', {
            params: { teamId }
        });
    },
    // Get avatar frame data 
    getFrameData(agentId) {
        let timezone = util.getCookie('timezone');
        return axios.get(`/api-site/festival/info/${agentId}`, {
            params: {
                timezone
            }
        });
    }
};
